class BannerModel {
  constructor(obj) {
    this.image_url = process.env.VUE_APP_STATIC_URL + process.env.VUE_APP_HOMEPAGE_IMG_NAME;

    if (obj) {
      Object.assign(this, obj);
    }
  }

  get dto() {
    return this;
  }
}

export default BannerModel;
